<template>

    <div class="container">

        <account-link />

        <div class="my-4">
            <h1>{{ __('Adressen') }}</h1>
        </div>

        <div v-if="addresses.length === 0">
            {{ __('Keine Adressen') }}
        </div>

        <div class="my-4">
            <inertia-link :href="route('addresses.create')" class="btn btn-lg btn-outline-primary">
                <i class="bi bi-plus-lg"></i>
                {{ __('Adresse erstellen') }}
            </inertia-link>
        </div>

        <div class="row row-cols-1 row-cols-md-3 g-4" v-if="addresses.length">
            <div class="col" v-for="address in addresses">
                <div class="card h-100 shadow-sm">
                    <div class="card-body">

                        <div class="d-grid mb-2" v-if="action">
                            <inertia-link :href="route('addresses.select-address')" :data="{ action: 'select_billing_address', id: address.id }" method="post" class="btn btn-lg btn-success" v-if="action === 'select_billing_address'">
                                {{ __('Als Rechnungsadresse wählen') }}
                            </inertia-link>
                            <inertia-link :href="route('addresses.select-address')" :data="{ action: 'select_delivery_address', id: address.id }" method="post" class="btn btn-lg btn-success" v-if="action === 'select_delivery_address'">
                                {{ __('Als Lieferadresse wählen') }}
                            </inertia-link>
                        </div>

                        <div class="mb-2">
                            <span class="badge bg-primary" v-if="address.is_default_billing_address">
                                {{ __('Standard Rechnungsadresse') }}
                            </span>
                            <span class="badge bg-primary" v-if="address.is_default_delivery_address">
                                {{ __('Standard Lieferadresse') }}
                            </span>
                        </div>

                        <div class="card-text">
                            <div v-html="address.formatted_output"></div>
                        </div>
                        <p class="card-text" v-if="address.notes">
                            {{ address.notes }}
                        </p>

                        <div class="mb-2">
                            <inertia-link :href="route('addresses.edit', address)" class="btn btn-outline-primary">
                                {{ __('Bearbeiten') }}
                            </inertia-link>
                            <button type="button" class="btn btn-outline-danger"  @click="destroy(address)">
                                {{ __('Löschen') }}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import AccountLink from '@/shared/AccountLink';

    export default {
        props: [
            'action',
            'addresses',
        ],
        data() {
            return {
            }
        },
        components: {
            AccountLink,
        },
        watch: {
        },
        methods: {
            destroy(address) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('addresses.destroy', address))
                }
            },
        },
    }
</script>